/**
 * API Configuration. getBaseUrl() uses runtime value from /api/config (set by ConfigLoader).
 */

const DEFAULT = "http://localhost:3001";

export function getBaseUrl(): string {
  if (typeof globalThis !== "undefined") {
    const url = (globalThis as { __API_BASE_URL?: string }).__API_BASE_URL;
    if (url) return url;
  }
  return process.env.NEXT_PUBLIC_API_BASE_URL || DEFAULT;
}

export const API_CONFIG = {
  get BASE_URL(): string {
    return getBaseUrl();
  },
  TIMEOUT: 50000,
} as const;
